import "./Home.scss";
import Logo from "../Atoms/Logos/Logo";
import styled from "@emotion/styled";
import GreenBtnB from "../Atoms/Buttons/RedBtnB";
import { sendCPLog } from "../../Utils/Log/CPlog";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import CardRtan from "../Atoms/Rtans/CardRtan";
import {
  grayScale,
  mBody3,
  mHeader1,
  mTitle3,
} from "@teamsparta/design-system";
import { Tooltip } from "../Atoms/Tooltip/Tooltip";
import {Footer} from '../Organism/Footer/Footer'

const Home = () => {
  const navigate = useNavigate();
  useEffect(() => {
    sendCPLog("nb_quiz_view", {});
  }, []);
  return (
    <>
      <Wrapper className={"home"}>
        <Logo />
        <H3>숨어있던 국비지원금, 나만 몰랐어..?</H3>
        <Title>국카찬스</Title>
        <CardRtan />
        <GrayBoxContainer>
          <GrayBox>
            <GrayBoxText>확인한 사람</GrayBoxText>
            <GrayBoxTextBold>10만명</GrayBoxTextBold>
            <TooltipWrapper>
              <Tooltip />
            </TooltipWrapper>
          </GrayBox>
          <GrayBox>
            <GrayBoxText>인당 최대 혜택 금액</GrayBoxText>
            <GrayBoxTextBold>2,000만원</GrayBoxTextBold>
          </GrayBox>
        </GrayBoxContainer>

        <GreenBtnB
          onClick={() => {
            sendCPLog("nb_quiz_click_button", {
              button_text: "10초 퀴즈 START",
            });
            navigate("/nb/selection");
          }}
        >
          10초 만에 국비지원금 확인하기
        </GreenBtnB>

        <Caption>*개인정보 처리방침에 동의합니다.</Caption>
        
      </Wrapper>
      <Footer/>
    </>
  );
};
export default Home;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 48px;
  margin-bottom: 60px;
`;

const H3 = styled.h3`
  margin-top: 20px;
  font-weight: 500;

  ${mTitle3};
`;

const Title = styled.div`
  margin-top: 16px;
  margin-bottom: 20px;

  object-fit: contain;
  font-family: "Cafe24Ohsquare";
  font-size: 46px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  position: relative;
`;

const Caption = styled.div`
  margin-top: 16px;
  width: 201px;
  height: 23px;
  flex-grow: 0;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.03px;
  text-align: center;
  color: #6b6e72;
`;

const NewChangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 328px;
  height: 47px;
  margin-top: 80px;
  margin-bottom: 8px;
`;

const NewChangeFirstLine = styled.div`
  display: flex;
  flex-direction: row;
`;

const NewChangeContent = styled.div`
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 600;
  color: #141617;
`;

const NewChangeSecondLine = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 55px;
`;

const NewChangeSecondContent = styled.div`
  color: #1d5b22;
  font-size: 13px;
  font-family: Pretendard;
  font-weight: 600;
  opacity: 0.7;
  margin-right: 4px;
`;

const NewChangeSecondSub = styled.div`
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 600;
  color: #1d5b22;
  opacity: 0.3;
`;

const GrayBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  margin-top: 60px;
  margin-bottom: 97px;

  position: relative;
`;

const GrayBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  gap: 20px;

  width: 328px;
  height: 66px;

  background: ${grayScale.gray0};

  border: 1px solid #f2f6f8;
  border-radius: 12px;
`;

const GrayBoxText = styled.div`
  ${mBody3};
  color: ${grayScale.gray60};
`;

const GrayBoxTextBold = styled.div`
  ${mHeader1};
`;

const TooltipWrapper = styled.div`
  position: absolute;
  top: -40px;
  right: 0px;
`;
